import axios from 'axios';
import Notify from 'quasar/src/plugins/Notify.js';;

export default function setup() {
  axios.interceptors.response.use((response) => {
    //console.log('interceptors axios response=%o',response)
    if(response.data && response.data.status && response.data.status==='error' && response.data.message){
      Notify.create({
        color: 'red',
        textColor: 'white',
        type: 'negative',
        message: response.data.message,
        position: 'top',
        timeout: 3500,
        html: true
      })
    } else if(response.data && response.data.status && response.data.status==='warning' && response.data.message){
      Notify.create({
        color: 'orange',
        textColor: 'white',
        type: 'warning',
        message: response.data.message,
        position: 'top',
        timeout: 3500,
        html: true
      })
    }
    return response;
  }, (error) => {
    const error_details = Object.values(error.response).toString();
    Notify.create({
      color: 'red',
      textColor: 'white',
      type: 'negative',
      message: error_details,
      position: 'top',
      timeout: 3500,
      html: true
    })
    return Promise.reject(error);
  });
}
